import React from "react";

const HOW_IT_WORKS_IMAGE = `${process.env.PUBLIC_URL}/images/How it works.svg`;

export default function MissionSection() {
  return (
    <section className="about-mission">
      <div className="about-mission__inner">
        <div className="about-mission__copy">
          <div className="about-mission__pill">MISSION</div>
          <h2>
            Knowledge should work for the enterprise – securely, intelligently, and in real time.
          </h2>
          <p>
            At Highwatch AI, we believe enterprise knowledge should be as trusted and accessible as
            your most critical system. Our mission is to unify, secure, and operationalize knowledge
            – eliminating silos, ensuring compliance, and empowering teams to act with clarity and
            confidence.
          </p>
        </div>
        <div className="about-mission__visual">
          <img src={HOW_IT_WORKS_IMAGE} alt="How Highwatch works in Slack" />
        </div>
      </div>
    </section>
  );
}
